import React, { useRef, useState } from "react";
import Form from "react-bootstrap/Form";
import LoaderButton from "../components/LoaderButton";
import { onError } from "../libs/errorLib";
import config from "../config";
import { s3Upload } from "../libs/awsLib";
import { s3ListFiles } from "../libs/awsLib";
import { getFilenameAndExtension} from  "../libs/awsLib";
import { Link } from "react-router-dom";

export default function Upload() {
  const file = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [fileExtension, setFileExtension] = useState("");
  const [S3FileName, setS3FileName] = useState("");

  function handleFileChange(event) {
    file.current = event.target.files[0];
    let fileExtension_ = getFilenameAndExtension(file.current.name)[1];
    setFileExtension(fileExtension_);
    if (fileExtension_ !== ".csv") {
      alert("Invalid file type : \"" + fileExtension_ + "\". Only .csv files accepted.");
    }
  }

  function validateForm() {
    return fileExtension === '.csv';
  }
 
  async function handleSubmit(event) {
    event.preventDefault();
  
    if (file.current && file.current.size > config.MAX_ATTACHMENT_SIZE) {
      alert(
        `Please pick a file smaller than ${
          config.MAX_ATTACHMENT_SIZE / 1000000
        } MB.`
      );
      return;
    }
  
    setIsLoading(true);
  
    try {
      setS3FileName("")
      var S3key = file.current ? await s3Upload(file.current) : "";
      setS3FileName(S3key);
      //console.log('upload s3key: ' + S3key + ' | s3filename: ' + S3FileName);
      setIsLoading(false);
      //alert(S3FileName);
      await s3ListFiles('')
  
    } catch (e) {
      onError(e);
      setIsLoading(false);
    }
  }
  
 
  return (
    <div>
      <main className="flex-shrink-0">
        <div className="container">
          <h4 className="mt-3">Upload a CSV Data File</h4>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="file">
              <Form.Label><br/>Select local csv file* to upload:</Form.Label>
              <Form.Control onChange={handleFileChange} type="file" accept=".csv" />
            </Form.Group>
            <LoaderButton
              // block
              type="submit"
              size="md"
              variant="primary"
              isLoading={isLoading}
              disabled={!validateForm()}
            >
              Upload File
            </LoaderButton>
          </Form>
          <br /><br />
          {S3FileName.length > 0  &&
            <div>
              <p>Successfully uploaded file: {S3FileName}<br /><br /></p>
            </div>
          }
          <p>* Single instrument CSV file names should be prefixed with 'SYMBOL_' followed by frequency e.g. SPY_monthly.csv, with header row consisting of "Date" plus "Adj Close", 
            "Close", "Price", or "Value" column names.</p>
          <p>CSV file names with multiple instruments should be prefixed with 'db_' followed by frequency e.g. db_monthly.csv, with header row consisting of "Date", "SYMBOL0", "SYMB1", etc
             column names.</p>
          <p><Link to="/data/view">Click here</Link> to download and view example files.</p>
        </div>
      </main>
    </div>
  );
}
